import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { config } from "../services/config";
import { isStSignupAllowed } from "./stSignupAccess";

interface STGuardProps {
    component?: React.ComponentType<any>;
    children?: React.ReactNode;
}

/**
 * STGuard - Protection des routes en mode ST exclusif
 *
 * Si REACT_APP_ST_ONLY_MODE=true :
 * - PERMET /auth/login (secours mot de passe)
 * - PERMET /auth/signup uniquement avec ?ALLOW=1|true|yes
 * - Redirige le reste vers /st-portal
 */
const STGuard: React.FC<STGuardProps> = ({ component: Component, children }) => {
    const location = useLocation();

    if (config.app.stOnlyMode) {
        if (location.pathname === '/auth/login') {
            if (Component) {
                return <Component />;
            }
            return <>{children}</>;
        }

        if (location.pathname === '/auth/signup') {
            if (isStSignupAllowed(location.search)) {
                if (Component) {
                    return <Component />;
                }
                return <>{children}</>;
            }
            return <Navigate to="/st-portal" replace state={{ reason: 'signup_blocked' }} />;
        }

        return <Navigate to="/st-portal" replace />;
    }

    if (Component) {
        return <Component />;
    }

    return <>{children}</>;
};

export default STGuard;
